import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { ORDER_ONLINE_URL } from "../lib/links";

// The old /order "coming soon" page is retired. Anyone hitting /order
// (old links, bookmarks) is sent straight to the live Flipdish ordering page.
export default function OrderRedirect() {
  useEffect(() => {
    window.location.replace(ORDER_ONLINE_URL);
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center bg-[#F7F5F0] text-[#1A1A1A] px-6 text-center" data-testid="order-redirect">
      <Loader2 className="h-7 w-7 animate-spin text-[#C8102E]" />
      <p className="mt-5 font-display text-2xl uppercase tracking-tight">Taking you to ordering…</p>
      <p className="mt-2 text-sm text-[#5C5C5C]">
        If nothing happens,{" "}
        <a href={ORDER_ONLINE_URL} className="text-[#C8102E] underline underline-offset-2">
          tap here to order online
        </a>
        .
      </p>
      <p className="mt-6 max-w-md text-xs text-[#5C5C5C] leading-relaxed" data-testid="order-allergen-notice">
        Allergen information is shown on the ordering page. Our food is prepared in a kitchen that
        handles nuts, gluten, milk, eggs and other allergens. If you have an allergy or intolerance,
        please check before ordering or contact us.
      </p>
    </div>
  );
}
